import { useState } from "react";

export default function Accordion({
  items,
}: {
  items: { q: string; a: string }[];
}) {
  const [openIdx, setOpenIdx] = useState<number>(0);
  return (
    <div className="flex flex-col gap-3">
      {items.map((item, idx) => {
        const open = openIdx === idx;
        return (
          <div
            key={idx}
            className="overflow-hidden rounded-lg border border-background-200/70 bg-background-50"
          >
            <button
              type="button"
              onClick={() => setOpenIdx(open ? -1 : idx)}
              aria-expanded={open}
              className="flex w-full cursor-pointer items-center justify-between gap-4 px-4 py-4 text-left md:px-6 md:py-5"
            >
              <span className="flex items-center gap-3">
                <span
                  className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-sm font-bold ${
                    open ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"
                  }`}
                >
                  {String(idx + 1).padStart(2, "0")}
                </span>
                <span className="font-heading text-base font-bold text-foreground-950 md:text-lg">
                  {item.q}
                </span>
              </span>
              <i
                className={`ri-add-line text-xl text-foreground-600 transition-transform ${
                  open ? "rotate-45" : ""
                }`}
              ></i>
            </button>
            <div
              className={`grid transition-all duration-300 ${
                open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
              }`}
            >
              <div className="overflow-hidden">
                <p className="px-4 pb-5 pl-16 text-sm leading-7 text-foreground-600 md:px-6 md:pl-16 md:text-base">
                  {item.a}
                </p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}